mutation SetYouTubeInvite($email: String!, $invited: Boolean!) {
  result: StreamToolsSetYouTubeInvite(email: $email, invited: $invited) {
    accountId
    youtubeChatInvited
    previousValue
    revocation {
      hadConnection
      disconnected
      purgeComplete
      consentCleared
    }
  }
}
